import React,{useState,useEffect,useRef} from "react";
import styled from "@emotion/styled/macro";
import { 
    Grid2 as Grid,
    Tooltip,
    IconButton
} from "@mui/material";
import ArrowTopIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

const StyledGridContainer = styled(Grid)`
    height: 100%;
    font-family: poppins;
    min-width: 200px;
    margin: 1vh auto;
    margin-bottom: 10px;
    background-color: white;
    overflow: hidden;
    text-align: center;
`;



const Scroller = ({scrollPosition}) => {
    const scrollerRef = useRef(null);
    const [relativePositionY, setRelativePositionY] = useState(0);
    const [animateScroller, setAnimateScroller] = useState(false);
    
    useEffect(() => {
        if (scrollerRef.current) {
          const rect = scrollerRef.current.getBoundingClientRect();
          const {bottom} = rect;
    
          setRelativePositionY(bottom);
          setAnimateScroller(relativePositionY <= window.innerHeight * 0.8 ? true : false);
        }
    }, [scrollPosition]);

    const returnToTop = (event) => {
        event.target.blur();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    const responsiveBackToTopButton = {
        color: {
            xs: animateScroller? "black" : "lightgray",
        },
        height: {
            xs: "64px"
        },
        width: {
            xs: "64px"
        },
        transition: {
            xs: "all 0s",
            md: "all 0.25s"
        },
        animation: animateScroller? "float 0.55s ease-in-out 0s infinite alternate-reverse" : "unset",
        "svg": {
            width: {
                xs: "32px"
            },
            height: {
                xs: "32px"
            }
        },
        '&:hover': {
            color: "black",
            scale: "1.10"
        },
        '&:active': {
            scale: "1.00",
            top: {
                xs: "5px",
                md: "2px"
            }
        },
        "@keyframes float": {
            from: {
                top: "-2.5px"
            },
            to: {
                top: "2.5px"
            }
        }
    };

    return ( 
        <StyledGridContainer container ref={scrollerRef}>
            <Grid size={12}>
                <Tooltip title="Return to top" placement="right-start">
                    <IconButton sx={responsiveBackToTopButton} onClick={(event) => returnToTop(event)} disableRipple>
                        <ArrowTopIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        </StyledGridContainer>
    );
}
 
export default Scroller;